<template>
  <p v-if="label">{{ label }}</p>
  <v-text-field
    v-model="inputValue"
    variant="outlined"
    density="compact"
    :color="color"
    :hide-details="hideDetails"
    :placeholder="placeholder"
    :suffix="suffix"
    :disabled="readonly"
    :error="error"
    :error-messages="errorMessages"
    :id="id"
    @keyup="emitInputValue()"
  />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    value: null | object | string;
    label?: string;
    suffix?: string;
    readonly?: boolean;
    error?: boolean;
    errorMessages?: string;
    color?: string;
    id?: string;
    placeholder?: string;
    hideDetails?: boolean;
  }>(),
  {
    label: "",
    readonly: false,
    color: "fieldOutlineColor",
    hideDetails: false,
  }
);

const emit = defineEmits<{
  (e: "updateEvent", newDate: string): void;
}>();

const inputValue = ref((props.value as unknown as string) ?? "");

watch(props, () => {
  inputValue.value = (props.value as unknown as string) ?? "";
});

function emitInputValue(): void {
  emit("updateEvent", inputValue.value);
}
</script>
